import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from '../../services/api.service';
import { ApiAnalyticsService } from '../../services/api-analytics.service';
import { DataService } from "../../services/data.service";
import { Subscription } from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { URL_IMG } from '../../constants/general';
 
@Component({
  selector: 'app-prof-address',
  templateUrl: './prof-address.component.html',
  styleUrls: ['./prof-address.component.scss'],
  host:{
    'class':'col forms-confirmation-style d-flex justify-content-center first-address-content'
  }
})
export class ProfAddressComponent implements OnInit {

  form: UntypedFormGroup;
  subscription: Subscription;
  typesAddress:any[]=[];
  typesAddressRadio:any[]=[]; 
  typesAddressOption:any[]=[]; 
  dataTypeAddress = {
    proof_address_name: '',
    radio_type_address: '',
    select_type_address: '',
    cx_contenido_domicilio: '',
    cx_nombre_documento: '',
    cx_formato_documento: '',
    file_base64: '',
    cx_tipo_domicilio: ''
  }
  invalidSizeFile:boolean=false;
  invalidExtFile:boolean=false;
  invalidNameFile:boolean=false;
  msgErrorFile:string='';
  url_img = URL_IMG;

  constructor(private formBuilder:UntypedFormBuilder, 
              private spinner: NgxSpinnerService,
              private router: Router,
              private api: ApiService,
              private apiAnalytics :ApiAnalyticsService,
              private data: DataService,
              private modalService: NgbModal) 
  { 
    this.validateSession();
    this.getTypesAddress();
    this.buildForm();
    this.subscribeFile();
  }

  validateSession() {    
    if( sessionStorage.getItem('data_proof_address') ) {
      this.dataTypeAddress = JSON.parse( sessionStorage.getItem('data_proof_address') ); 
      console.log(this.dataTypeAddress);  
    }
  }

  subscribeFile() {
    this.subscription = this.data.fileProofAddress.subscribe(file => this.dataTypeAddress.file_base64 = file);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.data.setStep('opciones/autonomo-comprobante');
  }

  previous(type) {
    console.log(`Autonomo | Paso1 | CDomicilio | ${type}Regresar`);
    this.apiAnalytics.gTag(`Autonomo | Paso1 | CDomicilio | ${type}Regresar`, 'Autonomo | Paso1 | CDomicilio', 'Tres Pasos Bursanet','1');
    this.router.navigate(['/opciones/autonomo-identificacion'])
  }

  getTypesAddress() {
    this.spinner.show();
    this.api.getTypesAddress().subscribe((data: any[]) => {
      this.spinner.hide();
      if(data == undefined) {
        this.radioTypeAddress.setValue(0);
        this.setRequiredOptions();
      } else {
        if(data.length > 0) {
          this.typesAddress = data;
          console.log(this.typesAddress);
          this.reOrderTypesAddress();
        } else {
          this.radioTypeAddress.setValue(0);
          this.setRequiredOptions();
        }        
      }      
    }, error => {
      this.spinner.hide();
      this.radioTypeAddress.setValue(0);
      this.setRequiredOptions();
      console.log('Error: ', error);
    });
  }

  reOrderTypesAddress() {
    let countRadio=0;
    let countOption=0;
    Object.keys(this.typesAddress).map((key) => {
      if(this.typesAddress[key].tipoDom != undefined && this.typesAddress[key].idTipoDom != undefined) {
        console.log(this.typesAddress[key].tipoDom.toLowerCase().trim())
        switch(this.typesAddress[key].tipoDom.toLowerCase().trim()){
          case 'casa':
            this.typesAddressRadio[countRadio]=this.typesAddress[key];
            countRadio++;
          break;
          case 'oficina':
            this.typesAddressRadio[countRadio]=this.typesAddress[key];
            countRadio++;
          break;
          default:
            this.typesAddressOption[countOption]=this.typesAddress[key];
            countOption++;
          break;
        }
      }         
    }); 

    if(this.typesAddressRadio.length == 0) {
      this.radioTypeAddress.setValue(0);
      this.setRequiredOptions();
    }
  }

  private buildForm() {
    let validators;
    if(this.dataTypeAddress.cx_contenido_domicilio !='') {
      validators = [];
    } else {
      validators = [Validators.required];
    }

    this.form = this.formBuilder.group({
      proof_address_name: [this.dataTypeAddress.proof_address_name, [Validators.required] ],
      file_proof: ['', validators ],
      radio_type_address: [this.dataTypeAddress.radio_type_address, [Validators.required] ],
      select_type_address: [this.dataTypeAddress.select_type_address]
    })
  }

  get proofAddressName(){
    return this.form.get('proof_address_name');
  }
  
  get radioTypeAddress(){
    return this.form.get('radio_type_address');
  }

  get selectTypeAddress(){
    return this.form.get('select_type_address');
  }

  get inputFileProof(){
    return this.form.get('file_proof');
  }

  showTextTypeProof(type):boolean {
    const proof = this.proofAddressName.value;
    if(type == '1' && proof == '1') {
      return false;
    } else if(type == '0' && proof == '0') {
      return false;
    }else {
      return true;
    }
  }

  setAnotherOption() {
    
    if(this.selectTypeAddress.value != '') {
      this.radioTypeAddress.setValue(0);      
      for (const item in this.typesAddress) {
        if(this.typesAddress[item].idTipoDom == this.selectTypeAddress.value) {
          this.dataTypeAddress.cx_tipo_domicilio = this.typesAddress[item].idTipoDom;
        }
      }
    } else {
      this.dataTypeAddress.cx_tipo_domicilio = '';
    }
    this.form.get('select_type_address').setValidators([Validators.required]);
    this.form.get('select_type_address').updateValueAndValidity();
    console.log(this.dataTypeAddress.cx_tipo_domicilio);
  }

  setRequiredOptions() {
    console.log(this.radioTypeAddress.value);
    if(this.radioTypeAddress.value == 0) {
      this.form.get('select_type_address').setValidators([Validators.required]);
      this.form.get('select_type_address').updateValueAndValidity();
      this.dataTypeAddress.cx_tipo_domicilio = '';
    } else {
      this.selectTypeAddress.setValue('');
      this.form.get('select_type_address').clearValidators();
      this.form.get('select_type_address').updateValueAndValidity();
      for (const item in this.typesAddress) {
        if(this.typesAddress[item].idTipoDom == this.radioTypeAddress.value) {
          this.dataTypeAddress.cx_tipo_domicilio = this.typesAddress[item].idTipoDom;
        }
      }
    }
    console.log(this.dataTypeAddress.cx_tipo_domicilio);
  }

  uploadFileAddress(event) {
    const fileList: FileList = event.target.files;
    console.log(fileList);

    if (fileList.length > 0) {

      if(fileList[0].name.length <= 50) {
        if (!this.validateSizeFile(fileList[0].size)) {
          console.log('Arhivo Invalido Tamaño');
          this.invalidExtFile = false;
          this.invalidNameFile=false;
          this.msgErrorFile='';
          this.clearInputFile();
          return;
        }

        if (!this.validateExtFile(fileList[0].name)) {
          console.log('Arhivo Invalido Extension');
          this.invalidSizeFile = false;
          this.invalidNameFile=false;
          this.msgErrorFile='';
          this.clearInputFile();
          return;
        }

        this.spinner.show();
        const file: File = fileList[0];
        const formData: FormData = new FormData();
        formData.append('file-all', file, file.name);
        formData.append('currentFile-all', '0');

        this.api.actionUploadFile(formData).subscribe((data: any) => {
          this.spinner.hide();   
          if(data == null || data == undefined) {
            this.invalidSizeFile= false;
            this.invalidExtFile = false;
            this.invalidNameFile=false;
            this.clearInputFile();
            this.msgErrorFile='Error al invocar el servicio';
          } else {
            this.invalidSizeFile= false;
            this.invalidExtFile = false;
            this.invalidNameFile=false;
            if(data.Status == "Error") {
              this.msgErrorFile=data.Description;
              this.clearInputFile();
            } else {
              this.dataTypeAddress.cx_contenido_domicilio = data.Code;
              this.dataTypeAddress.cx_nombre_documento = data.nombre;
              this.dataTypeAddress.cx_formato_documento = data.formato;
              this.dataTypeAddress.file_base64= data.fullBase64;
              this.msgErrorFile='';
            }          
          }                
        }, error => {
          this.spinner.hide();
          this.clearInputFile();
          console.log(error);
        });
      } else {
        this.clearInputFile();
        this.invalidSizeFile = false;
        this.invalidExtFile = false;
        this.invalidNameFile=true;
        this.msgErrorFile='';
      }
    } else {     
      this.clearInputFile();
    }   
  }

  clearInputFile() {
    this.dataTypeAddress.cx_contenido_domicilio = '';
    this.dataTypeAddress.cx_nombre_documento = '';
    this.dataTypeAddress.cx_formato_documento = '';
    this.dataTypeAddress.file_base64= '';
    this.inputFileProof.setValue('');
    this.inputFileProof.setValidators([Validators.required]);
    this.inputFileProof.updateValueAndValidity();
  }

  validateSizeFile (size):boolean {
    const mb = size / 1024;
    console.log(mb);
    if (mb >= 5000) {
      this.invalidSizeFile = true;
      return false;
    } else {
      this.invalidSizeFile = false;
      return true;
    }
  }

  validateExtFile(fileName): boolean {
    const extension =  ( fileName.split('.').pop() ).toLowerCase();
    console.log(extension);
    if (extension !== 'jpg' && extension !== 'png' && extension !== 'pdf' && extension !== 'jpeg') {
      this.invalidExtFile = true;
      return false;
    } else {
      this.invalidExtFile = false;
      return true;
    }
  }

  showInputFile() {
    if(this.proofAddressName.value == '') {
      return true;
    } else {
      if(this.dataTypeAddress.file_base64 == '') {
        return false;
      } else {
        return true;
      }
    }
    
  }

  showImageAddress():boolean {
    if(this.dataTypeAddress.file_base64 != '') {
      return false;
    } else {
      return true;
    }
  }

  showFile():boolean {
    if(this.dataTypeAddress.file_base64 == '') {
      return true;
    } else {
      return false;
    }
  }

  showImgPdf(format):boolean {
    let ext:string
    ext = this.dataTypeAddress.cx_formato_documento;

    switch(ext) {
      case 'image/jpeg':
        if(format == 'img') {
          return false;
        } else {
          return true;
        }
        break;
      case 'image/png':
        if(format == 'img') {
          return false;
        } else {
          return true;
        }
        break;
      case 'application/pdf':
        if(format == 'pdf') {
          return false;
        } else {
          return true;
        }
        break;
      default:
        return true;
        break;      
    }
  }

  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {      
    });
  }  

  saveStepOne(event:Event) {

    event.preventDefault();
    this.form.markAllAsTouched();
    console.log(this.form.valid)
    if(this.form.valid) {  

      let type = '';
      if(this.proofAddressName.value == '1') {
        type ='AMiNombre';
      } else if(this.proofAddressName.value == '0') {
        type ='AOtroNombre';
      }
      
      console.log(` Autonomo | Paso1 | CDomicilio | ${type} | Continuar`);
      this.apiAnalytics.gTag(` Autonomo | Paso1 | CDomicilio | ${type} | Continuar`, 'Autonomo | Paso1 | CDomicilio', 'Tres Pasos Bursanet','1');
      
      this.dataTypeAddress.proof_address_name = this.proofAddressName.value;
      this.dataTypeAddress.radio_type_address = this.radioTypeAddress.value;
      this.dataTypeAddress.select_type_address = this.selectTypeAddress.value;
      this.data.updateFileProofAddress(this.dataTypeAddress.file_base64);
      delete this.dataTypeAddress.file_base64;
      console.log(this.dataTypeAddress)     

      sessionStorage.removeItem('data_proof_address');
      sessionStorage.setItem('data_proof_address', JSON.stringify(this.dataTypeAddress) );

      this.router.navigate(['opciones/autonomo-completa-informacion']);
    }
  }

}
